import React from "react";
import "./p2game.css";
import heroSmall from "../../images/hero-small.svg";

const P2Game = () => {
    return (
        <div className="p2game">
            <div className="p2game-heading">
                <div>
                    <h2>
                        Legends of Shangu <span>P2E Game</span>
                    </h2>
                </div>
            </div>

            <div className="p2game-content">
                <p>
                    “We have already commenced development on our official
                    Legends of Shangu P2E game that will allow NFT holders to
                    play as their NFT avatars as they take on the Mutant Lord,
                    Nian as he attempts to resurrect his army of mutants back to
                    enslave the earth once more. Legends battle to find the
                    sacred artefacts needed to bring Nian back to a Mortal state
                    to then unite once more to destroy him and send him and his
                    army back to the underworld where they belong. The Awakening
                    is coming…”
                </p>
                <img src={heroSmall} alt="" />
            </div>
        </div>
    );
};

export default P2Game;
